import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';

import cx from 'classnames';
import FlagIcon from './flag-icon';
import FormInputErrorMessage from './form-input-error-message';
import FormInputLabel from './form-input-label';
import KeyMap from '../../utilities/keymap';
import TranslatedCopy from '../../intl/translated-copy';
import { injectIntl } from 'react-intl';
import { normalizeString } from '../../utilities/booker-helpers';

const mapStateToProps = state => ({
  helperTraslatedCopy: state.LanguageBundle.helperTraslatedCopy,
});

class FormInputDatalist extends Component {
  static defaultProps = {
    isListOptions: false,
    placeholderCopyID: 'BKN_RESIDENCE_WRITTING',
    tabIndex: 0,
  }

  constructor(props) {
    super(props);

    /**
     * @prop {Boolean} inFocus - input enfocado
     * @prop {Number} highlightedIndex - seleccionar opción con el teclado
     */
    this.state = {
      highlightedIndex: 0,
      inFocus: false,
      inputValue: '',
    };
  }

  componentDidMount() {
    const { 
      countrySuggestion,
      options, 
    } = this.props;
    const { 
      onBlur,
      value, 
    } = this.props.input;
    const countryListSize = [
      ...options,
      ...countrySuggestion,
    ];

    if (value) {
      const savedCountry = countryListSize.find(el => el.value === value);
      const currentInputValue = savedCountry && savedCountry.name ? savedCountry.name : '';
      
      this.setState({ inputValue: currentInputValue }); // eslint-disable-line
      onBlur();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { countrySelect } = this.props;
    const {
      highlightedIndex,
      inFocus,
      inputValue,
    } = this.state;
    
    if (prevState.inFocus !== inFocus && !inFocus) {
      window.removeEventListener('keydown', this.handleKeyDown);
    } else if (prevState.inFocus !== inFocus && inFocus) {
      window.addEventListener('keydown', this.handleKeyDown);
    }

    if (prevState.inputValue !== inputValue && highlightedIndex !== 0) {
      this.formInputDatalistContainer.scrollTop = 0;
      this.setState({ highlightedIndex: 0 });
    }

    if (prevProps.countrySelect !== countrySelect) {
      const { onBlur } = this.props.input;
      onBlur();
      this.countryInput.blur();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  }

  render() {
    const {
      inputClassModifier,
      isEnrollmentModal,
      isRequired,
      labelCopyID,
    } = this.props;

    const {
      error,
      touched,
      valid,
    } = this.props.meta;

    const {
      name,
      value,
    } = this.props.input;

    const isError = Boolean(error && touched);
    const isValid = valid && value && touched;

    const labelClasses = cx({
      'FormEnrollmentCountryResidence': isEnrollmentModal,
      'is-error': isEnrollmentModal && isError,
      'is-correct': isEnrollmentModal && isValid,
    });

    return (
      <div className={`FormInput FormInput--datalist ${ inputClassModifier } ${ labelClasses }`} >
        <FormInputLabel
          isRequired={ isRequired }
          labelCopyID={ labelCopyID }
          name={ name } />
        { this.renderSelect() }
        { isError &&
          <FormInputErrorMessage
            error={ error }
            errorWidth={ 236 }
            name={ name } />
        }
      </div>
    );
  }

  renderSelect() {
    const {
      countrySelect,
      intl,
      isEnrollmentModal,
      isListOptions,
      placeholderCopyID,
      tabIndex,
      helperTraslatedCopy,
    } = this.props;

    // Guard: si intl no está disponible, usar helperTraslatedCopy como fallback
    const formatMessage = (intl && typeof intl.formatMessage === 'function')
      ? intl.formatMessage.bind(intl)
      : ({ id }) => (helperTraslatedCopy ? helperTraslatedCopy.getFormatMessageFromcopyId(id) : id);
    const { inFocus, inputValue } = this.state;
    const { name } = this.props.input;
    const {
      error,
      touched,
      valid,
    } = this.props.meta;
    const dataListValue = (countrySelect && countrySelect !== '') ? countrySelect : isListOptions ? 
      inputValue ? formatMessage({ id: inputValue }) : formatMessage({ id: placeholderCopyID }) 
      : inputValue;
    const dataListType = isListOptions ? 'button' : 'search';
    const copyIdPlaceHolder = helperTraslatedCopy.getFormatMessageFromcopyId(isEnrollmentModal ? 'APP_SELECT' : 'BKN_RESIDENCE_WRITTING');
    const handleChangeCountry = (e) => {
      const { resetCountry } = this.props;
      
      if (resetCountry) {
        resetCountry();
      }

      this.setState({ inputValue: e.target.value }); 
    };

    const handleOnMouseClick = () => {
      const { resetCountry } = this.props;

      if (resetCountry) {
        resetCountry();
      }

      if (isListOptions) {
        this.countryInput.focus();
        this.setState({ inFocus: true });
      }
    };

    const handleOnMouseDown = (e) => isListOptions ? {} : this.inputClean(e);
    const isError = error && touched;
    const isValid = valid && dataListValue && touched;
    const isSearch = !inputValue || !inFocus;
    const formFieldClasses = cx({
      'FormInputDatalist-wrapper': true,
      'FormInputDatalist-wrapper--isError': isError,
      'FormInputDatalist-wrapper--isCorrect': isValid,
      'FormInputDatalist-wrapper--isInFocus': inFocus,
    });

    const iconClass = cx({
      'DataListForm-icon': true,
      'DataListForm-icon--search Icon Icon--search': isSearch && !isListOptions,
      'DataListForm-icon--xThin Icon Icon--xThin': !isSearch && !isListOptions,
      'DataListForm-icon--arrowSmallDown Icon Icon--arrowSmallDown': isListOptions,
    });

    const iconClassEnrollment = cx('DataListForm-iconEnrollment', {
      'DataListForm-iconEnrollment--arrowSmallDown Icon Icon--arrowSmallDown': isSearch,
      'DataListForm-iconEnrollment--xThin Icon Icon--xThin': !isSearch,
    });

    const inputClass = cx({
      'FormInputDatalist-listTrigger': true,
      'FormInputDatalist-listTrigger--listOptions': isListOptions,
    });

    return (
      <div className='DataListForm'>
        <div className={ formFieldClasses }>
          <input className={ inputClass }
            aria-hidden={ true }
            autoComplete='off'
            id={ name }
            maxLength={ 50 }
            name={ name }
            onBlur={ this.handleBlur }
            onChange={ e => handleChangeCountry(e) }
            onClick={ () => handleOnMouseClick() }
            onFocus={ () => this.setState({ inFocus: true }) }
            placeholder={ copyIdPlaceHolder }
            ref={ n => this.countryInput = ReactDOM.findDOMNode(n) }
            spellCheck={ false }
            tabIndex={ tabIndex }
            type={ dataListType }
            value={ dataListValue } />
          <span
            className={ isEnrollmentModal ? iconClassEnrollment : iconClass }
            onClick={ () => handleOnMouseClick() }
            onMouseDown={ e => handleOnMouseDown(e) } />
        </div>
        { inFocus && this.renderResultList() }
      </div>
    );
  }
  
  inputClean = e => {
    e.preventDefault();
    
    this.setState({ inputValue: '' });

    if (this.formInputDatalistContainer) {
      this.formInputDatalistContainer.focus();
    }
  }

  renderResultList = () => {
    const { 
      countrySuggestion, 
      isListOptions, 
      options, 
    } = this.props;
    const countryOptionsSize = this.handleSearchCountry(options).length;
    const countrySuggestionsSize = this.handleSearchCountry(countrySuggestion).length;
    const invalidInput = !Boolean(countryOptionsSize + countrySuggestionsSize);

    const selectCountry = cx({
      'FormInputDatalist-options': true,
      'FormInputDatalist-options--info': true,
    });

    const withoutResultsClass = cx({
      'FormInputDatalist-options': true,
      'FormInputDatalist-options--withoutResults': true,
    });

    const formInputDatalist = cx({
      'FormInputDatalist-wrapperOptions': true,
      'FormInputDatalist-wrapperOptions--listOptions': isListOptions,
    });

    const showInfoSelect = Boolean(countryOptionsSize && !isListOptions);

    return (
      <ul
        className={ formInputDatalist }
        ref={ n => this.formInputDatalistContainer = ReactDOM.findDOMNode(n) } >
        { this.handleSuggestions() }
        { showInfoSelect &&
          <TranslatedCopy
            className={ selectCountry }
            copyID='BKN_SELECT_COUNTRY'
            tagName='li' 
          />
        }
        { this.renderList() }
        { invalidInput &&
          <TranslatedCopy
            className={ withoutResultsClass }
            copyID='BKN_FIELD_NOT_RESULTS'
            tagName='li' 
          />
        }
      </ul>);
  }

  handleSuggestions = () => {
    const { countrySuggestion } = this.props;
    const { highlightedIndex } = this.state;

    const countryOption = index => cx({
      'FormInputDatalist-options': true,
      'FormInputDatalist-options--suggestions': true,
      'FormInputDatalist-options--currentSelect': index === highlightedIndex,
    });

    const searchResults = this.handleSearchCountry(countrySuggestion);

    return searchResults.map((option, i) => {
      const sfSuggestion = option.value ? option.value.toLowerCase() : '';

      return (
        <li
          className={ countryOption(i) }
          key={ option.value }
          onMouseDown={ () => this.handleSelectCountry(option.name) } >
          <FlagIcon svgID={ sfSuggestion } className='Dropdown-flagIcon' />
          <span className='FormInputDatalist-suggestionTitle'>{ option.name }</span>
          <TranslatedCopy
            className='FormInputDatalist-suggestionsText' 
            copyID='BKN_RESIDENCE_FIELD_SUGGEST'
          />
        </li>);
    });
  }

  renderList = () => {
    const formatMessage = (this.props.intl && typeof this.props.intl.formatMessage === 'function')
      ? this.props.intl.formatMessage.bind(this.props.intl)
      : ({ id }) => (this.props.helperTraslatedCopy ? this.props.helperTraslatedCopy.getFormatMessageFromcopyId(id) : id);
    const { highlightedIndex, inputValue } = this.state;
    const { 
      countrySuggestion, 
      isListOptions, 
      options, 
    } = this.props;

    const countryOption = index => cx({
      'FormInputDatalist-options': true,
      'FormInputDatalist-options--currentSelect': isListOptions ? inputValue === index : index === highlightedIndex,
      'FormInputDatalist-options--listOptions': isListOptions,
    });

    const searchOptionsResults = isListOptions ? options : this.handleSearchCountry(options);
    const suggestionsResultsSize = this.handleSearchCountry(countrySuggestion).length;

    return searchOptionsResults.map((option, i) => {
      const name = option.name ? option.name : '';
      const index = suggestionsResultsSize + i;
      const liClassName = isListOptions ? countryOption(option.name) : countryOption(index);
      const liText = isListOptions ? formatMessage({ id: option.copyID }) : name;
      const key = option.value ? option.value : i;

      return (
        <li
          className={ liClassName }
          key={ key }
          onMouseDown={ () => this.handleSelectCountry(option.name) } >
          { liText }
        </li>);
    });
  }

  handleSelectCountry = country => {
    const { resetCountry } = this.props;

    if (resetCountry) {
      resetCountry();
    }
    
    this.setState({ inputValue: country });
  }

  handleSearchCountry = list => {
    const { inputValue } = this.state;

    if (inputValue) {
      return list.filter(el => {
        const country = el.name && normalizeString(el.name).toLowerCase();
        const search = normalizeString(inputValue).toLowerCase();
        
        return country && country.includes(search);
      });
    } else {
      return list;
    }
  }

  handleBlur = (countryCode = false) => {
    const { 
      countrySuggestion,
      input: {
        onBlur,
        onChange,
      },
      options, 
    } = this.props;
    const { inputValue } = this.state;

    let currentCountryCode = countryCode;

    if (typeof currentCountryCode !== 'string') {
      const list = [
        ...this.handleSearchCountry(options),
        ...this.handleSearchCountry(countrySuggestion),
      ];
      const findCountry = list.find(el => el.name === inputValue);
      currentCountryCode = findCountry ? findCountry.value : '';
    }

    onChange(currentCountryCode);

    this.setState({ inFocus: false });

    onBlur();

    this.countryInput.blur();
  }

  handleScrollDataList = (keyCode, sizeList) => {
    const { highlightedIndex } = this.state;
    const { countrySuggestion } = this.props;

    const countrySuggestionSize = this.handleSearchCountry(countrySuggestion).length;
    const sizeLi = highlightedIndex > countrySuggestionSize ? 30 : 45;
    const toleranceDown = 4;
    const toleranceUp = 6;
    const isNotMaxScrollDow = highlightedIndex + toleranceDown < sizeList;
    const isNotMaxScrollUp = highlightedIndex < sizeList - toleranceUp;
    const scrollY = this.formInputDatalistContainer.scrollTop;

    if (keyCode === KeyMap.UP && isNotMaxScrollUp && scrollY) {
      this.formInputDatalistContainer.scrollTo(0, scrollY - sizeLi);
    } else if (keyCode === KeyMap.DOWN && isNotMaxScrollDow) {
      this.formInputDatalistContainer.scrollTo(0, scrollY + sizeLi );
    }
  }

  handleKeyDown = e => {
    const { highlightedIndex } = this.state;
    const { options, countrySuggestion } = this.props;

    const list = [
      ...this.handleSearchCountry(countrySuggestion),
      ...this.handleSearchCountry(options),
    ];
    const sizeList = list.length;
    const kyesPreventDefault = [
      KeyMap.ENTER,
      KeyMap.ESCAPE,
      KeyMap.DOWN,
      KeyMap.RETURN,
      KeyMap.UP,
    ];

    if (kyesPreventDefault.includes(e.keyCode)) {
      e.preventDefault();
    }

    if (e.keyCode === KeyMap.UP && highlightedIndex) {
      this.setState(prevState => ({
        highlightedIndex: prevState.highlightedIndex - 1,
      }));
      
      this.handleScrollDataList(KeyMap.UP, sizeList);
    } else if (e.keyCode === KeyMap.DOWN && highlightedIndex < sizeList - 1) {
      this.setState(prevState => ({
        highlightedIndex: prevState.highlightedIndex + 1,
      }));

      this.handleScrollDataList(KeyMap.DOWN, sizeList);
    } else if (e.keyCode === KeyMap.RETURN && sizeList) {
      // seleccionar al precionar enter
      const findCountry = list[highlightedIndex];
      const countryName = findCountry && findCountry.name ? findCountry.name : '';
      const countryCode = findCountry && findCountry.value ? findCountry.value : '';
      this.setState({ inputValue: countryName });
      this.handleBlur(countryCode);
    }
  }
}

FormInputDatalist = connect(mapStateToProps)(FormInputDatalist);

export default injectIntl(FormInputDatalist);
